<div></div>
<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="user.firstName"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="name"
				[defaultFilterLabel]="filterLabels.name"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.name }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('name')"
								data-automation-id="name-input"
								(ngModelChange)="dataSet.filter('name', filterLabels.name, $event)"
							/>
						</mat-form-field>
					</div>

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.email }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('email')"
								data-automation-id="email-input"
								(ngModelChange)="dataSet.filter('email', filterLabels.email, $event)"
							/>
						</mat-form-field>
					</div>

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.phoneNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('phoneNumber')"
								data-automation-id="phone-number-input"
								(ngModelChange)="dataSet.filter('phoneNumber', filterLabels.phoneNumber, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('active')"
								data-automation-id="status-picker"
								(ngModelChange)="dataSet.filter('active', filterLabels.status, $event, statusFilterOptions)"
							>
								@for (option of statusFilterOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.label">{{
										option.label
									}}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>

					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.roleName }}</mat-label>
							<input
								matInput
								data-automation-id="role-name-input"
								[ngModel]="dataSet.filter('roleName')"
								(ngModelChange)="dataSet.filter('roleName', filterLabels.roleName, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (canShowUserManagementActions && !showWhitelistedUsers) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@userDirectory-AddButton"
					(click)="navigateToAddUser()"
					data-automation-id="user-directory-add-user-button"
				></app-data-set-action-button>
			</div>
			<div class="user-toggle">
				<mat-slide-toggle
					labelPosition="before"
					[(ngModel)]="showAllUsers"
					(change)="showInactiveUsers()"
					i18n="@@userDirectory-showInactiveUsersLabel"
					data-automation-id="show-inactive-users-toggle"
					>Show Inactive Users &nbsp;
				</mat-slide-toggle>
			</div>
		}

		@if (showWhitelistedUsers) {
			<app-button-toggle
				[activeLeftButtonIcon]="'sl-hamburger-menu-active'"
				[inactiveLeftButtonIcon]="'sl-hamburger-menu-inactive'"
				[activeRightButtonIcon]="'sl-three-users-active'"
				[inactiveRightButtonIcon]="'sl-three-users-inactive'"
				[(selectedButton)]="selectedButton"
				(selectedButtonChange)="whitelistPageChanged($event)"
			></app-button-toggle>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(getCompanyUsersByCompanyIdLoadingKey) ||
				loadingService.isLoading(resendUserRegistrationLoadingKey) ||
				!finishedLoadingInitData
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="
					loadingService.isLoading(getCompanyUsersByCompanyIdLoadingKey) ||
					loadingService.isLoading(resendUserRegistrationLoadingKey) ||
					!finishedLoadingInitData
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td
						class="mat-cell"
						[colSpan]="displayedColumns.length"
						i18n="@@dataSetTable-noRecordsFound"
						class="font-color-gray"
					>
						No records found.
					</td>
				</tr>
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userDirectory-Name2">Name</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">{{ row.user.firstName }} {{ row.lastName }}</td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userDirectory-Email2">Email</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">{{ row.user.email }}</td>
				</ng-container>

				<ng-container matColumnDef="phoneNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userDirectory-Phone2">Phone Number</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">{{ row.user.phoneNumber | phoneNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userDirectory-userStatus">Status</th>
					<td mat-cell *matCellDef="let row">
						@if (row.user.verified === true && row.user.active === true) {
							<span i18n="@@userDirectory-active" class="font-color-gray">Active</span>
						}
						@if (row.user.active === false) {
							<span i18n="@@userDirectory-inactive" class="font-color-red">Inactive</span>
						}
						@if (row.user.verified === false && row.user.active !== false) {
							<span i18n="@@userDirectory-pending" class="font-color-gray">Pending</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="roleName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userDirectory-role">Role</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">{{ row.roleName }}</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (!embeddedWritesBlocked) {
							<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'user-' + row.id + '-row'"
				></tr>
			</table>

			<mat-menu #menu="matMenu" class="hamburger-menu-container">
				<ng-template matMenuContent let-row="row">
					@if (canRemoveUser(row)) {
						<button
							mat-menu-item
							(click)="removeUser(row)"
							data-automation-id="user-directory-deactivate-user-button"
							i18n="@@userDirectory-deactivateUserMenuButton"
						>
							Deactivate User
						</button>
					}
					@if (canReactivateUser(row)) {
						<button
							mat-menu-item
							(click)="reactivateUser(row)"
							data-automation-id="user-directory-reactivate-user-button"
							i18n="@@userDirectory-reactivateUserMenuButton"
						>
							Reactivate User
						</button>
					}
					<button
						mat-menu-item
						(click)="onResendRegistrationClick(row)"
						i18n="@@userDiroctory-resendRegistration"
						[disabled]="row.user.verified === true"
						data-automation-id="user-directory-resend-registration-button"
					>
						Resend Registration
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
